<script lang="ts">
    export let seconds: number | null = null;
    export let displayFormat: 'duration' | 'time' = 'duration';
    export let showSign: boolean = false;
    export let prefix: string = '';
    export let reduceTo24h: boolean = false;

    type formattedTimeType = {
        sign: string;
        hours: string;
        minutes: string;
        separator: string;
    };

    let formatted: formattedTimeType = {
        sign: '',
        hours: '',
        minutes: '',
        separator: '',
    };

    let formattedTime = function (
        seconds: number,
        showSign: boolean = false,
        reduceTo24h: boolean = false
    ): formattedTimeType {
        if (reduceTo24h && seconds > 0) {
            seconds = seconds % (24 * 60 * 60);
        }
        let minutes = Math.floor(Math.abs(seconds) / 60);
        let hours = Math.floor(minutes / 60);
        minutes = minutes % 60;
        switch (displayFormat) {
            case 'duration':
                return {
                    sign: seconds < 0 ? '-' : showSign ? '+' : '',
                    hours: hours.toString(),
                    minutes: minutes.toString().padStart(2, '0'),
                    separator: 'h',
                };
            case 'time':
                return {
                    sign: seconds < 0 ? '-' : showSign ? '+' : '',
                    hours: hours.toString(),
                    minutes: minutes.toString().padStart(2, '0'),
                    separator: ':',
                };
            default:
                return {
                    sign: '',
                    hours: '*',
                    minutes: '**',
                    separator: ':',
                };
        }
    };

    $: if (seconds !== null) formatted = formattedTime(seconds, showSign, reduceTo24h);
</script>

{#if displayFormat === 'duration'}
    <div class="dont-break time-formatter duration">
        {prefix}{formatted.sign}{formatted.hours}
        <div class="time-separator time-separator-duration">{formatted.separator}</div>
        {formatted.minutes}
    </div>
{:else}
    <div class="dont-break time-formatter time">
        {prefix}{formatted.sign}{formatted.hours}
        <div class="time-separator time-separator-time">{formatted.separator}</div>
        {formatted.minutes}
    </div>
{/if}

<style>
    .time-formatter {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        justify-content: flex-end;
    }
    .time-separator {
        font-size: 0.7rem;
        opacity: 0.5;
    }
    .time-separator-duration {
        font-weight: 300;
        opacity: 0.6;
        margin: 0 3px 0 1px;
    }
    .time-separator-time {
        font-weight: 600;
        margin: 0 1px 0 1px;
    }
</style>
